import { Component, OnInit, Input, ViewChild, TemplateRef  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';

import { AddEditTestingBillComponent } from './addEditTestingBill.component';
import { TestingBillModel } from '../../../model/index';
import { TestingBillService, SubscribeService  } from '../../../services/index';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { Store } from '@ngrx/store';

@Component({
    selector: 'testingbill-tab',
    templateUrl: './testingBill.component.html',
})

export class TestingBillComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public testingbilldata: any[] = [];

    isLoadMask: Promise<any>;
    testingbillData: TestingBillModel[];
    isLoading: boolean = false;

    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    subscribeAuth;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    filterData = {
        "search_name": "",
        "from_date": new Date(),
        "to_date": new Date(),
        "usertype" : '',
        "branch" : '',
        "user_role_type" : '',

    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    //@ViewChild('testingamountTemplate') testingamountTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('printPage') printPage;
    columns = [];
    toggleCol = [];
    printConfig: any;

    constructor(public store: Store<fromRootStore.State>,private testingbillService: TestingBillService, public subscribeService: SubscribeService, private modalService: BsModalService) { }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Bill No', prop: 'auto_no', width: 90, minWidth: 90, maxWidth: 90 },
            { name: 'Date', prop: 'disp_date', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Client ID', prop: 'client_no', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Discount', prop: 'discount_amount', sortable: false, cellClass: 'cell-right', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Total', prop: 'amount', sortable: false, cellClass: 'cell-right', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Action', prop: 'sno', width: 250, minWidth: 250, maxWidth: 250, sortable: false,cellClass:'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
        this.subscribeService.publishReloadTestingBillListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });

 this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
        if (auth['islogin']) {
            this.filterData.user_role_type = auth['user_role_type'];
            this.filterData.usertype = auth['usertype'];
            this.filterData.branch = auth['branch_id'];
        }
    });

    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getTestingbillList();
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getTestingbillList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTestingbillList();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    applyFilter(): void {
        this.filterPanel.close();
        this.getTestingbillList();
    }
    getTestingbillList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                search_name: this.filterData['search_name'],
                from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            };

        this.isLoadMask = this.testingbillService
            .getTestingbillList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.testingbillData = res.data;
            });
    }

    addTestingbill(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'bill_id': '',
                'mode': mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        } else if (mode == "View") {
            row['mode'] = mode;
        }
        row['user_role_type'] = this.filterData.user_role_type;
        row['usertype'] =  this.filterData.usertype;  
        row['branchName'] =  this.filterData.branch;

        that.subscribeService.subScribeTabID('Transaction', 'AddEditTestingBillComponent', row, this['params']['tabParams']);
    }
    onDeleteTestingbill(row: any): void {
        let that = this,
            params = {
                bill_id: row.bill_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Testing Bill Details, No - ' + row['auto_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.loadingIndicator = true;
            that.isLoadMask = that.testingbillService
                .deleteTestingbill(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getTestingbillList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {
        });

    }

    onPrintReport(row:any) {	
        let that = this;	
        row['bill_no'] = row.auto_no;	
        row['payment'] = row.type;	
        this.printConfig = {	
            type: this.title,	
            title: 'SOUNDS GOOD HEARING CARE',	
            subTitle: this.title,	
            rows: row,	
            columns: that.columns	
        }	
        setTimeout(() => {	
            that.printPage.printPreview();	
        }, 100);	
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingBill/testingBill.component.ts